var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":`0 0 ${_vm.width} ${_vm.height}`,"aria-labelledby":_vm.icon,"role":"presentation"}},[_c('g',{domProps:{"innerHTML":_vm._s(require(`@/assets/svg/${this.icon}.svg`))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }